import React, { memo } from 'react';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  const scrollToPurchase = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative bg-gradient-to-b from-[#1a365d] to-[#2c5282] text-white pt-24 pb-16 px-4 md:pt-32 md:pb-24 overflow-hidden" data-id="element-44">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-45">
        <div className="space-y-6 text-center md:text-left z-10" data-id="element-46">
          <div className="inline-block bg-blue-800/50 border border-blue-400/30 rounded-full px-4 py-1 text-sm font-medium text-blue-200 mb-2" data-id="element-47">
            📘 Mapas Mentales de Anatomía Humana
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight tracking-tight" data-id="element-48">
            Comprende, memoriza y aprueba{' '}
            <span className="text-yellow-400" data-id="element-49">Anatomía</span> sin perder horas
            ni frustrarte
          </h1>

          <p className="text-lg md:text-xl text-blue-100 max-w-xl mx-auto md:mx-0" data-id="element-50">
            Todo lo que necesitas para estudiar Anatomía de forma clara, visual
            y efectiva, en un solo lugar.
          </p>

          <div className="pt-4" data-id="element-51">
            <button onClick={scrollToPurchase} className="w-full md:w-auto bg-yellow-500 hover:bg-yellow-400 text-blue-900 font-bold text-xl py-4 px-8 rounded-lg shadow-[0_4px_0_rgb(180,83,9)] hover:shadow-[0_2px_0_rgb(180,83,9)] hover:translate-y-[2px] transition-all flex items-center justify-center gap-2 group" data-id="element-52">
              ¡QUIERO ESTUDIAR MEJOR!
              <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-53" />
            </button>
            <p className="text-xs text-blue-300 mt-3 text-center md:text-left" data-id="element-54">
              🔒 Compra 100% segura y garantía de satisfacción
            </p>
          </div>
        </div>

        <div className="relative z-10 flex justify-center" data-id="element-55">
          <div className="relative w-full max-w-md cursor-pointer hover:scale-105 transition-transform duration-300" onClick={scrollToPurchase} data-id="element-56">
            <div className="absolute -inset-4 bg-blue-500/20 rounded-full blur-3xl" data-id="element-57"></div>
            <img src="https://cdn.magicpatterns.com/uploads/mYTtBZPeqV6p6KDq5WHDKk/1_Cover.png" alt="Mapas Mentales de Anatomía Humana Libro" className="relative z-10 w-full drop-shadow-2xl" data-id="element-58" />
          </div>
        </div>
      </div>

      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-blue-600/10 skew-x-12 transform origin-top-right" data-id="element-59"></div>
    </section>;
}